<template>
    <div >
        <Nav></Nav>
        <b-overlay :show="pageloading" rounded="sm">
            <PageHeader :linkto="'/home'" :linkttitle="'返回'" :title="productName"></PageHeader>

        <b-container class="bg-white p-3 p-md-5 shadow-sm rounded " >
            <b-form-select v-model="typeselected" :options="options" @change="loadType" class="mb-3"></b-form-select>
            <b-row class="mb-2" no-gutters>
                <b-col cols="8">
                    <b-form-input  v-model="searchkey" placeholder="請輸入姓名搜尋" ></b-form-input>
                    <b-form-invalid-feedback :state="searchCheck">
                        {{ searchRuleMsg }}
                    </b-form-invalid-feedback>
                </b-col>
                <b-col class="pl-2">
                    <b-button block variant="primary" v-if="!searchuse" @click="search" >搜尋</b-button>
                    <b-button block variant="primary" v-else @click="cencel" >取消</b-button>
                </b-col>
            </b-row>
            <hr>
            <b-card v-for="(item,index) in historylog" v-bind:key="index" :title="item.title "  class="mb-2"  header-tag="header">
                <template #header>
                    <div class="d-flex align-items-center">


                        <b-badge pill variant="primary" >{{ String(index+1) }}</b-badge>
                        <h6 class="ml-2 mb-0">{{ item.name}}</h6>
                    </div>

                </template>
                <b-card-text>
                    <!--{{ item.name }}-->
                </b-card-text>
                <a href="#" class="card-link" @click="viewHistory(item.ouid)">查看</a>
                <a href="#" class="card-link" @click="deleteHistory(item.ouid)">刪除</a>
                <b-card-text class="small float-right text-muted">{{item.create_date }}</b-card-text>
            </b-card>
            <b-card v-if="historylog.length==0" class="mb-2">
                <b-card-text>
                    <b-img center :src="require('../../assets/ui/emptybox.png')"  v-bind="{  width: 75, height: 75}"></b-img>
                    <p class="text-muted text-center">沒有任何紀錄資料</p>
                </b-card-text>
            </b-card>

            <b-button variant="primary" block @click="loadMore" v-if="!ListinEnd && !loadmoreswitch">讀取更多</b-button>
            <b-alert show variant="primary" class="d-flex justify-content-center pb-5 pt-5" v-if="loadmoreswitch">
                <b-spinner label="Loading..."></b-spinner>
                <strong class="ml-3 mt-2">讀取中</strong>
            </b-alert>
            <b-alert show variant="primary" class="d-flex justify-content-center pb-5 pt-5" v-if="ListinEnd && !loadmoreswitch">已無資料</b-alert>

        </b-container>
        </b-overlay>


    </div>


</template>

<script>

// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import PageHeader from '@/components/PageHeader.vue'

import {productdata} from '@/config/env';
import {mapState} from 'vuex'
import {toCurrency, alertModel } from '@/service/commuse'

export default {
  name: 'login',
  components: {Nav,PageHeader},
  data () {
    return {
      productName:'比對紀錄',
      typeselected: 1,
      options: productdata,
      pageloading: true,
      offset: 0,
      limite:20,
      loadmoreswitch:false,
      isLoadMore:false,
      ListinEnd:false,
      loadmorecount:1,
      loadmorelimite:20,
      searchkey:'',
      searchRuleMsg:'',
      searchCheck:false,
      searchuse:false
    }
  },
  computed: {
    ...mapState(['historylog']),
    rows() {
      return this.items.length
    },
  },
  created() {

  },
  mounted () {

    this.typeselected = this.$route.params.id?this.$route.params.id:5
    document.addEventListener("scroll",this.handleScroll)
   this.loadData()
  },
  methods: {
    checkvalue (way) {
      switch (way) {
        case 'searchkey':
          if (this.searchkey.length <= 1 ) {
            this.searchRuleMsg = '至少需輸入2個字元以上'
            this.searchCheck = false
          }else{
            this.searchRuleMsg = ''
            this.searchCheck = true
          }


          break

      }

    },
    cencel(){
      this.searchkey = ''
      this.searchuse = false
      this.loadData()
    },
    search(){
      this.searchuse = true
      this.checkvalue('searchkey')
      if(this.searchCheck){
        this.offset = 0
        this.loadData()
      }

    },
    loadData(){

      this.pageloading=true
      this.$store.dispatch('actionGetHistoryLog', {
        limit: this.limite,
        offset: this.offset,
        type:this.typeselected,
        search:this.searchkey
      }).then((res)=>{
        this.pageloading=false
      });
    },
    loadType(){
      this.searchkey = ''
      this.searchuse = false
      this.offset=0
      this.loadData()
    },
    loadMore(){
      if(!this.loadmoreswitch){

        this.offset = this.offset + 1



      this.loadmoreswitch=true
      this.$store.dispatch('actionGetHistoryLog', {
        limit: this.limite,
        offset: this.offset,
        type:this.typeselected
      }).then((res)=>{

        if (res.data.length == 0) {
          this.ListinEnd = true
          setTimeout(() => {
            this.ListinEnd = false
          }, 3000)

        }

        this.loadmoreswitch = false

      });


        // this.loadmoreswitch=true
        // this.$store.dispatch('actionGetHistoryLog', {
        //   limit: this.limite,
        //   offset: this.offset,
        //   type:this.typeselected
        // }).then((res)=>{
        //
        //   if(res.data.length == 0){
        //     this.ListinEnd = true
        //     setTimeout(()=>{
        //       this.ListinEnd = false
        //     },3000)
        //
        //   }
        //   this.loadmoreswitch=false
        //
        // });
      }

    },
    handleScroll() {
      // if(this.$route.path== '/HistoryLog'){
      //   let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      //   let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      //   let scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
      //   let total = scrollTop+windowHeight;
      //   if(total == scrollHeight && this.isLoadMore ){
      //     this.loadmore()
      //     this.isLoadMore = false
      //
      //   }
      //   if(total < scrollHeight  ){
      //     this.isLoadMore = true
      //   }
      // }

    },
    viewHistory(ouid){
      this.$store.dispatch('actionPostAnaHistory', {
        ouid: ouid,
        type:this.typeselected
      }).then((res) => {
        // console.log(res)
        this.openDetail(this.typeselected)
      }).catch((res) => {


      });
    },
    openDetail(puid){
      puid = puid.toString()
      switch (puid){
        case '1':
          this.$router.push('/Personality');
          break;
        case '2':
          this.$router.push('/Allyear');
          break;
        case '3':
          // phone
          this.$router.push('/PhoneVipResult');
          break;
        case '4':
          // 總體運勢
          this.$router.push('/OverallResult');
          break;
        case '5':
          // 客戶
          this.$router.push('/ClientResult/History');
          break;
        case '6':
          // 情侶
          this.$router.push('/LoverResult');
          break;
        case '7':
          // 親友
          this.$router.push('/ReleativeResult');
          break;
        case '8':
          // 職場
          this.$router.push('/ColleagueResult');
          break;
        case '9':
          // 高手過招
          this.$router.push('/MasterVipResult');
          break;

      }


      },
    deleteHistory(id){
      alertModel(this,"系統訊息","確定刪除此筆紀錄？").then(()=>{


        this.$store.dispatch('actionDisabledView', {
          ouid: id,
        }).then((res) => {

          this.loadData()
        }).catch((res) => {


        });
      })
    }


  }
}
</script>
